// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NS6Gg","left":"styles_left__2cHuL","right":"styles_right__1EWY6","alert":"styles_alert__2DPs3"};